import { render, staticRenderFns } from "./TextServicos.vue?vue&type=template&id=16845753&scoped=true"
import script from "./TextServicos.vue?vue&type=script&lang=js"
export * from "./TextServicos.vue?vue&type=script&lang=js"
import style0 from "./TextServicos.vue?vue&type=style&index=0&id=16845753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16845753",
  null
  
)

export default component.exports